import React from 'react'

export const Chat = () => {
    return (
        <div className='grid place-items-center h-full text-xl font-medium'>
           Chat With Annie cabs
        </div>
    )
}
